import Header from "./components/Header";
import SiteUpgrade from "./components/SiteUpgrade";
import styles from "./styles/App.module.css";

function App() {
  return (
    <div className={styles.page}>
      <Header />
      <SiteUpgrade />
    </div>
  );
}

export default App;